import React from 'react';
export function HeroSection() {
  return <section className="w-full bg-white pt-24 pb-12" data-id="element-1009">
      <div className="container mx-auto px-6" data-id="element-1010">
        <div className="flex flex-col md:flex-row" data-id="element-1011">
          <div className="w-full md:w-1/2 flex flex-col justify-center py-8" data-id="element-1012">
            <h1 className="text-4xl md:text-5xl font-normal text-black mb-6" data-id="element-1013">
              explorandoconfran
            </h1>
            <h2 className="text-xl md:text-2xl font-normal text-black mb-8" data-id="element-1014">
              Media Kit
            </h2>
            <p className="text-base md:text-lg text-gray-700 mb-4 max-w-md leading-relaxed" data-id="element-1015">
              Más de 17 mil almas curiosas me acompañan en cada camino. Juntos
              recorremos{' '}
              <span className="font-medium" data-id="element-1016">
                montañas, ríos y senderos que cuentan historias
              </span>
              … pero también exploramos lo que pasa dentro de nosotros.
            </p>
            <p className="text-base md:text-lg text-gray-700 mb-10 max-w-md leading-relaxed" data-id="element-1017">
              Aquí tu marca no solo aparece: se mete en la mochila, camina con
              nosotros y se vuelve parte de un viaje que{' '}
              <span className="font-medium" data-id="element-1018">inspira afuera y adentro</span>.
            </p>
            <div className="mb-10" data-id="element-1019">
              <span className="text-sm text-gray-600 mr-3" data-id="element-1020">#explora</span>
              <span className="text-sm text-gray-600 mr-3" data-id="element-1021">#aventuras</span>
              <span className="text-sm text-gray-600 mr-3" data-id="element-1022">#viajes</span>
              <span className="text-sm text-gray-600" data-id="element-1023">#crecimiento</span>
            </div>
            <a href="https://wa.me/16462819972" className="bg-black text-white px-8 py-3 text-sm uppercase w-max hover:bg-gray-800 transition-colors inline-block" data-id="element-1024">
              Colaboremos
            </a>
          </div>
          <div className="w-full md:w-1/2 h-[400px] md:h-auto mt-8 md:mt-0" data-id="element-1025">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jt4rCsvChGhB3sYBjCMymS/Untitled_design_-_2025-06-19T233717.679.png" alt="Fran explorando en las montañas" className="w-full h-full object-cover" data-id="element-1026" />
          </div>
        </div>
      </div>
    </section>;
}